import { FeatureFlagEnums } from "./featureFlags.type"

export interface UserInterface {
	userName: string
	firstName: string
	lastName: string
	email: string
	emailWhenMessage: boolean
	mobile: string
	telephone1: string
	telephone2: string
	isEnabled: boolean
	password?: string
	confirmPassword?: string
	shouldChangePassword: boolean
	roles: RoleInterface[]
	oldRoles: string[]
	expiryDate: string | null
	notes: string
	platform: string
	lastLogin?: string
	receiveNotifications?: boolean
	inactivityTimer?: number
}
export interface GetUserInterface extends UserInterface {
	_id: string
}

export interface UpdateUserInterface extends Partial<UserInterface> {
	_id: string
}

export interface RoleInterface {
	name: string
	companyId: string
	companyName: string
	functionsPermitted: string[]
	isOrganizationalAdmin: boolean | null
	hasCompanyWideAccess: boolean | null
	isAllBranchesAllowed: boolean | null
	isAllCustomersAllowed: boolean | null
	isAllEmployeesAllowed: boolean | null
	isAllSitesAllowed: boolean | null
	isAllSuppliersAllowed: boolean | null
	allowedResources?: {
		employee?: string[]
		site?: string[]
		branch?: string[]
		customer?: string[]
		supplier?: string[]
	} | null
	userId: string
}
export interface GetRoleInterface extends RoleInterface {
	_id?: string
}

export interface UpdateRoleInterface extends RoleInterface {
	_id: string
}

export interface UpdateUserPassword {
	currentPassword?: string
	newPassword: string
}

export enum SECURITY_TABS {
	USERS = "users",
}

export interface AdminSecurityOptions {
	label: string
	component: React.ReactNode
	perform: string | string[]
	featureName: FeatureFlagEnums
	value: SECURITY_TABS
}
